import { useUserPreferencesContext } from '../contexts/UserPreferencesContext';

export type {
  PreferenceValue,
  UserPreferences,
} from '../contexts/UserPreferencesContext';

export { UserPreferencesProvider } from '../contexts/UserPreferencesContext';

/** Shared user preferences (single load for the whole authenticated app shell). */
export const useUserPreferences = () => useUserPreferencesContext();

// Common preference keys
export const PREFERENCE_KEYS = {
  THEME: 'theme',
  LANGUAGE: 'language',
  TIMEZONE: 'timezone',
  CLOCK_24H: 'clock24h',
  DATE_FORMAT: 'dateFormat',
  NOTIFICATIONS_EMAIL: 'notifications.email',
  NOTIFICATIONS_PUSH: 'notifications.push',
  DASHBOARD_VIEW: 'dashboard.view',
  ITEMS_PER_PAGE: 'itemsPerPage',
  SIDEBAR_COLLAPSED: 'sidebar.collapsed',
  TIMESHEET_DEFAULT_WORKING_HOURS: 'timesheet.defaultWorkingHours',
} as const;

// Default preferences
export const DEFAULT_PREFERENCES = {
  [PREFERENCE_KEYS.THEME]: 'light',
  [PREFERENCE_KEYS.LANGUAGE]: 'en',
  [PREFERENCE_KEYS.TIMEZONE]: 'UTC',
  [PREFERENCE_KEYS.CLOCK_24H]: false,
  [PREFERENCE_KEYS.DATE_FORMAT]: 'MMM dd, yyyy',
  [PREFERENCE_KEYS.NOTIFICATIONS_EMAIL]: true,
  [PREFERENCE_KEYS.NOTIFICATIONS_PUSH]: false,
  [PREFERENCE_KEYS.DASHBOARD_VIEW]: 'list',
  [PREFERENCE_KEYS.ITEMS_PER_PAGE]: 10,
  [PREFERENCE_KEYS.SIDEBAR_COLLAPSED]: false,
  [PREFERENCE_KEYS.TIMESHEET_DEFAULT_WORKING_HOURS]: {
    monday: { enabled: true, hours: 8 },
    tuesday: { enabled: true, hours: 8 },
    wednesday: { enabled: true, hours: 8 },
    thursday: { enabled: true, hours: 8 },
    friday: { enabled: true, hours: 8 },
    saturday: { enabled: false, hours: 0 },
    sunday: { enabled: false, hours: 0 },
  } as const,
} as const;
